import { graphql, useStaticQuery } from "gatsby";

export const Images = () => {
  return useStaticQuery(graphql`
      query {
          list_bg: file(
              relativePath: { eq: "images/cases/rowerowa-przygoda/list/background.png" }
          ) {
              childImageSharp {
                  fluid(maxWidth: 564, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          list_detail: file(
              relativePath: { eq: "images/cases/rowerowa-przygoda/list/detail.png" }
          ) {
              childImageSharp {
                  fluid(maxWidth: 673, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }

          img_1: file(
              relativePath: { eq: "images/cases/rowerowa-przygoda/content/img_1.png" }
          ) {
              childImageSharp {
                  fluid(maxWidth: 1410, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }

          img_2: file(
              relativePath: { eq: "images/cases/rowerowa-przygoda/content/img_2.png" }
          ) {
              childImageSharp {
                  fluid(maxWidth: 1410, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }

          img_3: file(
              relativePath: { eq: "images/cases/rowerowa-przygoda/content/img_3.png" }
          ) {
              childImageSharp {
                  fluid(maxWidth: 1410, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }

          img_4: file(
              relativePath: { eq: "images/cases/rowerowa-przygoda/content/img_4.png" }
          ) {
              childImageSharp {
                  fluid(maxWidth: 1410, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }

          img_5: file(
              relativePath: { eq: "images/cases/rowerowa-przygoda/content/img_5.png" }
          ) {
              childImageSharp {
                  fluid(maxWidth: 1410, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }

          img_6: file(
              relativePath: { eq: "images/cases/rowerowa-przygoda/content/img_6.png" }
          ) {
              childImageSharp {
                  fluid(maxWidth: 364, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }

          full_1: file(
              relativePath: { eq: "images/cases/rowerowa-przygoda/full/full_1.png" }
          ) {
              childImageSharp {
                  fluid(maxWidth: 1920, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }

          full_2: file(
              relativePath: { eq: "images/cases/rowerowa-przygoda/full/full_2.png" }
          ) {
              childImageSharp {
                  fluid(maxWidth: 1920, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
      }
  `);
};
